import {
  MCC_FULFILLMENT_METHOD_DIRECT_DELIVERY,
  KITCHEN_PACKAGE,
  APPLIANCE_PACKAGE_PRIORITIES
} from '../constants';

export const buildCartRequestParams = (products, zip) => {
  return products.map(({ itemId }) => ({ itemId,
    quantity: 1,
    fulfillmentMethod: MCC_FULFILLMENT_METHOD_DIRECT_DELIVERY,
    fulfillmentLocation: zip || '' }));
};

const getHostName = () => {
  let host = 'https://www.homedepot.com';
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    host = origin.match(/local/g) ? 'https://www.homedepot.com' : origin;
  }
  return host;
};

const enhanceMetadataOptions = (metadata) => {
  return {
    brandImage: metadata.brandImage?.url || '',
    heroImage: metadata.heroImage?.url || '',
    packageBrand: metadata.brandName,
    packageImage: metadata.image?.url?.replace(/<SIZE>/g, '400') || '',
    packageName: metadata.name
  };
};

export const getCartOptions = (products, metadata, channel) => {
  const defaultParams = {
    host: getHostName(),
    channel,
    paypal: false,
    misship: false,
    sharedSection: KITCHEN_PACKAGE
  };
  if (products.length === 1) {
    return defaultParams;
  }
  return { ...defaultParams, packageInfo: { ...metadata, ...enhanceMetadataOptions(metadata) } };
};

export const getDynamicImages = (products) => {
  const activeProducts = products.filter((product) => {
    return product.active;
  }).map((product) => {
    return {
      url: product.media.image.url,
      itemId: product.itemId,
      productGroupLabel: product.info.productGroup,
      active: !product.removed
    }
  }).sort((p1, p2) => {
    if (!!p1.productGroupLabel && !!p2.productGroupLabel) {
      return (
        APPLIANCE_PACKAGE_PRIORITIES.indexOf(p1.productGroupLabel)
          > APPLIANCE_PACKAGE_PRIORITIES.indexOf(p2.productGroupLabel)
      ) ? 1 : -1;
    }
    return 0;
  });
  return activeProducts;
};